// extracted by mini-css-extract-plugin
export default {"sectionTitle":"General_sectionTitle__1o5wJ","sectionCaption":"General_sectionCaption__+qWKU"};